export { default } from "./styled.js";